import { render, staticRenderFns } from "./documentStatus.vue?vue&type=template&id=c762bda4&"
import script from "./documentStatus.vue?vue&type=script&lang=js&"
export * from "./documentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports